import {
  formatter,
  numberOfVotesLabelParser,
} from '../formatter';

export const numberOfVotesLabelFormatter = formatter({
  parser: numberOfVotesLabelParser,
});
